import React, { ReactNode, useEffect, useState } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '../../i18n';

interface I18nProviderProps {
  children: ReactNode;
}

interface I18nProviderState {
  isInitialized: boolean;
  error: string | null;
}

const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const [state, setState] = useState<I18nProviderState>({
    isInitialized: false,
    error: null,
  });

  useEffect(() => {
    const initializeI18n = async (): Promise<void> => {
      try {
        if (!i18n.isInitialized) {
          await i18n.init();
        }
        setState({
          isInitialized: true,
          error: null,
        });
      } catch (error) {
        setState({
          isInitialized: false,
          error: error instanceof Error ? error.message : 'Failed to initialize i18n',
        });
      }
    };

    initializeI18n();
  }, []);

  if (state.error) {
    return (
      <div role="alert" style={{ color: 'red', padding: '1rem' }}>
        Error initializing translations: {state.error}
      </div>
    );
  }

  if (!state.isInitialized) {
    return <div style={{ padding: '1rem' }}>Loading translations...</div>;
  }

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

export default I18nProvider;
